// extracted by mini-css-extract-plugin
export default {"textProduct":"text_textProduct__Qcr9n","iconImage":"text_iconImage__A0LTz"};